module.exports = __webpack_public_path__ + "static/media/table-2.8cd42557.webp";